export default "__VITE_ASSET__vv1fAjzY__$_?url__"